<template>
  <div class="yama-banner">
    <!-- Use existing Banner component -->
    <Banner
      :is-start-game="isStartGame"
      :has-time-record="hasTimeRecord"
      :inject-key="injectKey"
      @open-qa="$emit('open-qa')"
      @open-record="$emit('open-record')"
      @action-start="$emit('action-start')"
    />
  </div>
</template>

<script>
import Banner from '../banner.vue';

/**
 * Yama Banner wrapper component following SOLID principles
 * Single Responsibility: Wraps existing Banner with consistent interface
 * Interface Segregation: Clean props and events interface
 * Dependency Inversion: Depends on existing Banner abstraction
 */
export default {
  name: 'YamaBanner',
  
  components: {
    Banner
  },
  
  props: {
    isStartGame: {
      type: Boolean,
      default: false
    },
    hasTimeRecord: {
      type: Boolean,
      default: false
    },
    injectKey: {
      type: Object,
      default: () => ({})
    }
  },
  
  emits: [
    'open-qa',
    'open-record',
    'action-start'
  ]
};
</script>

<style lang="scss" scoped>
.yama-banner {
  // Additional styling if needed
  // The existing Banner component handles most styling
  position: relative;
  z-index: 10;
}

// Responsive adjustments
@media (max-width: 768px) {
  .yama-banner {
    // Mobile-specific adjustments if needed
  }
}
</style>